export default {
  features: {
    warehouseItemToggleAlifshopOfferVisibility: {
      show: "Sotuvga qo'yish",
    },
  },
};
